import { ErrorMessage, Field, Form, FormikProvider, useFormik } from 'formik'
import React, { useEffect, useState } from 'react'
import { Col, Container, Row, Table } from 'react-bootstrap';
import { CommonAxiosGet, CommonAxiosPost } from '../../CommonUtils/CommonAxios';
import * as Yup from "yup";
import { failureAlert, successAlert2 } from '../../CommonUtils/SweetAlerts';
import { config } from '../../CommonUtils/CommonURLS';
import Swal from 'sweetalert2';
import { ERROR_MSG } from '../../CommonUtils/contextVariables';

export default function IntakeVariations() {

    const [getRatio, setRatio] = useState([])
    const [isSubmitted, setIsSubmitted] = useState(false);

    /* ================= VALIDATION ================= */
    const validationSchema = Yup.object({
        ratioList: Yup.array().of(
            Yup.object().shape({
                remarks: Yup.string()
                    .required(ERROR_MSG)

            })
        )
    });

    /* ================= API 1 ================= */
    function GetIntakeDetails() {
        let url = config.url.FAC_URL + "getIntakeVariationdtls";
        CommonAxiosGet(url).then((res) => {
            if (res?.data?.status === true) {
                setRatio(res?.data?.data || [])
            } else {
                setRatio([])
            }
        })
    }

    useEffect(() => {
        GetIntakeDetails()
    }, [])

    /* ================= INITIAL VALUES ================= */
    const getInitialValues = () => ({
        ratioList: getRatio.map(() => ({
            remarks: "",

        }))
    });

    /* ================= FORMIK ================= */
    const formik = useFormik({
        initialValues: getInitialValues(),
        enableReinitialize: true,
        validationSchema: validationSchema,
        validateOnBlur: true,
        validateOnChange: false,
        onSubmit: (values) => {
            intakeVariationSubmit(values)
        }
    });

    /* ================= SUBMIT ================= */
    function intakeVariationSubmit(values) {
        Swal.fire({
            title: "Are you sure?",
            text: "Do you want to submit?",
            icon: "warning",
            showCancelButton: true,
            confirmButtonText: "Yes, Submit",
            cancelButtonText: "No, Cancel"
        }).then((result) => {
            if (result.isConfirmed) {
                let url = config.url.FAC_URL + "saveIntakeVariationDetails"
                const payload = {
                    intakeVariationDetails: getRatio.map((item, index) => ({
                        courseCode: item.course_id,
                        sanctionedIntake: item.sanction_intake,
                        increaseReductionChange: item.nature,
                        change: item.change,
                        effectiveIntake: item.effective_intake,
                        recommended: values.ratioList[index].remarks
                    }))

                }

                CommonAxiosPost(url, payload).then((res) => {
                    if (res?.data?.scode === "01") {
                        successAlert2(res.data.sdesc)
                        getFinalRatioData();
                    } else {
                        failureAlert(res?.data?.sdesc)
                    }
                })
            }
        });
    }

    /* ================= FINAL DATA ================= */
    const [finalData, setFinalData] = useState([]);

    function getFinalRatioData() {
        const url = config.url.FAC_URL + "getIntakeVariationDetails";

        CommonAxiosGet(url)
            .then((res) => {
                if (res?.data?.status === true) {

                    const data = res.data.data || [];

                    setFinalData(data);
                    // setIsSubmitted(data.length > 0);
                    const status = data.some(item => item.recommended === "Yes" || item.recommended === "No");
                    setIsSubmitted(status);
                    // const status = data.recommended;
                    console.log(">>>>>>>>>>>", status)
                    // setIsSubmitted(status === true || status === "true");
                    const mappedData = data.map((item) => ({
                        sno: item.sno || "",
                        increaseReductionChange: item.increase_reduction_change || "",
                        collCode: item.coll_code || "",
                        change: item.change || "",
                        effectiveIntake: item.effective_intake || "",
                        recommended: item.recommended || "",
                        courseCode: item.course_code || "",
                        acYear: item.ac_year || "",
                        sanctionedIntake: item.sanctioned_intake || "",

                        // 🔥 FIX
                        remarks: item.recommended || ""
                    }));
                    // ✅ Set entire array at once
                    formik.setFieldValue("ratioList", mappedData);

                } else {
                    setFinalData([]);
                    setIsSubmitted(false);
                    formik.setFieldValue("ratioList", []);
                }
            })
            .catch(() => {
                setFinalData([]);
                setIsSubmitted(false);
                formik.setFieldValue("ratioList", []);
            });
    }

    useEffect(() => {
        if (getRatio.length > 0) {
            getFinalRatioData();
        }
    }, [getRatio])

    // const getSignedChange = (item) => {
    //     const val = item?.change || 0;

    //     switch (item?.nature?.toLowerCase()) {
    //         case "increase":
    //         case "newcourse":
    //             return `+${val}`;
    //         case "reduction":
    //             return `-${val}`;
    //         default:
    //             return val;
    //     }
    // };

    return (
        <Container fluid className="py-3">
            <FormikProvider value={formik}>
                <Form onSubmit={formik.handleSubmit}>
                    <h5 className="mb-3 innerheader-new text-success">
                        <b>Intake Variations</b>
                    </h5>

                    <Row className="mt-4">
                        <Col xs={12}>


                            {/* <Table bordered responsive>
                                <thead className='table-primary'>
                                    <tr>
                                        <th>S.No</th>
                                        <th>Academic Program Type</th>
                                        <th>Course / Program</th>
                                        <th>Branch / Specialization</th>
                                        <th>Sanctioned Intake</th>
                                        <th>Seats Applied for Increase (+) /<br /> Reduction (–) / Change </th>
                                        <th> Change </th>

                                        <th>Total Effective Intake </th>
                                        <th>Recommended  </th>

                                    </tr>
                                </thead>

                                <tbody>
                                    {getRatio.length > 0 ? getRatio.map((item, index) => (
                                        <tr key={index}>
                                            <td>{index + 1}</td>
                                            <td>{item.course_group_desc || "-"}</td>
                                            <td>{item.course_cat_name || "-"}</td>
                                            <td>{item.course_name || "-"}</td>
                                            <td className="text-end">{item?.sanction_intake}</td>
                                            <td className="text-end">{item?.change}</td>
                                            <td className="text-end">{item?.nature}</td>
                                            <td className="text-end">{item?.effective_intake}</td>



                                            <td>
                                                <Field
                                                    type="radio"
                                                    name={`ratioList.${index}.remarks`}
                                                    value="Yes"
                                                    // disabled={!!formik.values.ratioList[index]?.remarks}
                                                    disabled={finalData[index]?.recommended === "Yes" || finalData[index]?.recommended === "No"}
                                                />&nbsp; Yes

                                                &emsp;
                                                <Field
                                                    type="radio"
                                                    name={`ratioList.${index}.remarks`}
                                                    value="No"
                                                // disabled={!!formik.values.ratioList[index]?.remarks}
                                                disabled={finalData[index]?.recommended === "Yes" || finalData[index]?.recommended === "No"}
                                                />&nbsp; No

                                                <ErrorMessage
                                                    name={`ratioList.${index}.remarks`}
                                                    component="div"
                                                    className="text-danger"
                                                />
                                            </td>
                                        </tr>
                                    )) : (
                                        <tr>
                                            <td colSpan="6" className="text-center text-danger">
                                                ***No Data Found***
                                            </td>
                                        </tr>
                                    )}
                                </tbody>
                            </Table>

                            {isSubmitted ? (
                                <p className="text-success fw-bold mt-2 text-end">
                                    ✅ Already Submitted
                                </p>
                            ) : (
                                <Row className="mt-4">
                                    <Col xs={12} className="text-end">
                                        <button type="submit" className="btn btn-primary">
                                            Submit
                                        </button>
                                    </Col>
                                </Row>


                            )} */}
                            {getRatio.length === 0 ? (
                                <div className="text-center text-danger fw-bold mt-4">
                                    *** No Data Found ***
                                </div>
                            ) : (
                                <>
                                    <Table bordered responsive>
                                        <thead className='table-primary'>
                                            <tr>
                                                <th>S.No</th>
                                                <th>Academic Program Type</th>
                                                <th>Course / Program</th>
                                                <th>Branch / Specialization</th>
                                                <th>Sanctioned Intake</th>
                                                <th>Seats Applied for Increase (+) /<br /> Reduction (–) / Change </th>
                                                <th>Change</th>
                                                <th>Total Effective Intake</th>
                                                <th>Recommended</th>
                                            </tr>
                                        </thead>

                                        <tbody>
                                            {getRatio.map((item, index) => (
                                                <tr key={index}>
                                                    <td>{index + 1}</td>
                                                    <td>{item.course_group_desc || "-"}</td>
                                                    <td>{item.course_cat_name || "-"}</td>
                                                    <td>{item.course_name || "-"}</td>
                                                    <td className="text-end">{item?.sanction_intake}</td>
                                                    <td className="text-end">{item?.change}</td>
                                                    <td className="text-end">{item?.nature}</td>
                                                    <td className="text-end">{item?.effective_intake}</td>

                                                    <td>
                                                        <Field
                                                            type="radio"
                                                            name={`ratioList.${index}.remarks`}
                                                            value="Yes"
                                                            disabled={finalData[index]?.recommended === "Yes" || finalData[index]?.recommended === "No"}
                                                        />&nbsp; Yes

                                                        &emsp;

                                                        <Field
                                                            type="radio"
                                                            name={`ratioList.${index}.remarks`}
                                                            value="No"
                                                            disabled={finalData[index]?.recommended === "Yes" || finalData[index]?.recommended === "No"}
                                                        />&nbsp; No

                                                        <ErrorMessage
                                                            name={`ratioList.${index}.remarks`}
                                                            component="div"
                                                            className="text-danger"
                                                        />
                                                    </td>
                                                </tr>
                                            ))}
                                        </tbody>
                                    </Table>

                                    {/* ✅ Submit Section */}
                                    {isSubmitted ? (
                                        <p className="text-success fw-bold mt-2 text-end">
                                            ✅ Already Submitted
                                        </p>
                                    ) : (
                                        <Row className="mt-4">
                                            <Col xs={12} className="text-end">
                                                <button type="submit" className="btn btn-primary">
                                                    Submit
                                                </button>
                                            </Col>
                                        </Row>
                                    )}
                                </>
                            )}
                        </Col>
                    </Row>
                </Form>
            </FormikProvider>
        </Container>
    )
}